module.exports = __webpack_public_path__ + "img/detail-banner.9f92467b.jpg";